import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';

import { BaseUiModule } from '@mitsubishi/shared/ui';
import { AutocompleteComponent } from '@mitsubishi/ui/autocomplete';
import { UiDatepickerModule } from '@mitsubishi/ui/datepicker';
import { EditorComponent } from '@mitsubishi/ui/editor';
import { UiFileInputModule } from '@mitsubishi/ui/file-input';

import { NewsAdminDialogCreationStepComponent } from './news-admin-dialog-creation-step/news-admin-dialog-creation-step.component';
import { NewsAdminDialogTagStepComponent } from './news-admin-dialog-tag-step/news-admin-dialog-tag-step.component';
import { NewsAdminDialogVisibilityStepComponent } from './news-admin-dialog-visibility-step/news-admin-dialog-visibility-step.component';
import { NewsAdminDialogComponent } from './news-admin-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    BaseUiModule,
    MatStepperModule,
    ReactiveFormsModule,
    AutocompleteComponent,
    EditorComponent,
    UiFileInputModule,
    UiDatepickerModule,
  ],
  declarations: [
    NewsAdminDialogComponent,
    NewsAdminDialogCreationStepComponent,
    NewsAdminDialogTagStepComponent,
    NewsAdminDialogVisibilityStepComponent,
  ],
  exports: [],
})
class NewsAdminDialogModule {}
